import { Autocomplete, AutocompleteChangeDetails, Button, Checkbox, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import _ from 'lodash';
import React, { } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Utility from '../../../../app/utility';
import { MarketInfoType } from '../../../MarketInfo/models/MarketInfoQueryModel';
import { SupportSheetHelpTextConstant } from '../../models/SupportSheetHelperTextConstant';
import SupportSheetHelpText from '../SupportSheetHelpText/SupportSheetHelpText';
import SupportSheetInvoiceModel from './models/SupportSheetInvoiceModel';
import './SupportSheetInvoice.scss';
import { getErrorClass, hasError } from '../../SupportSheetBiefInformation';
import { SupportSheetSelector } from '../../reducers/SupportSheetReducer';
import SupportSheetPeriod from '../SupportSheetPeriod/SupportSheetPeriod';
import FixtureApi, { SetFixtureDoneParam } from '../../../FixtureManagement/api/FixtureApi';
import BaseResponse from '../../../../app/BaseResponse';
import { showLoading } from '../../../LoadingView/reducers/LoadingViewReducer';

export interface SupportSheetInvoiceInputProp {
    collectCommFrom: string,
    commTerm: string,
    total: string,
    ours: string,
    coBrk: string,
}

interface SupportSheetInvoiceProp {
    selectedItems: SupportSheetInvoiceModel[],
    input: SupportSheetInvoiceInputProp,
    type: string,
    viewMode: boolean,
    className?: string,
    onInputChange?: (input: SupportSheetInvoiceInputProp) => void,
    onInvoiceClick?: () => void,
    onSelectedItemChange?: (selectedItems: SupportSheetInvoiceModel[]) => void,
}

export const getDefaultInvoices = () => {
    return [{
        invoiceNo: "",
        issDate: "",//Date
        amount: null,
        rcvDate: "",//Date
        forPeriodFrom: "",//Date 
        forPeriodTo: "",//Date 
    } as SupportSheetInvoiceModel];
}

const SupportSheetInvoice: React.FunctionComponent<SupportSheetInvoiceProp> = (props) => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);

    return (
        <>
            <div>
                <b>BROKERAGE INVOICE
                    {!props.viewMode &&
                        <SupportSheetHelpText helpText={SupportSheetHelpTextConstant['Brokerage invoice']}></SupportSheetHelpText>}
                </b>
            </div>
            <TextField
                label="Comm term"
                fullWidth
                value={props.input.commTerm ? props.input.commTerm : ""}
                error={
                    hasError(supportSheetData.enableValidation, supportSheetData.model.commTerm)
                }
                className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.commTerm)}
                onChange={(event) => {
                    props.input.commTerm = event.target.value;
                    if (props.onInputChange) {
                        props.onInputChange(props.input);
                    }
                }}
            />
            <Grid container className='cargo-input-component'>
                <Grid item xs={4}>
                    Collect our comm from
                </Grid>
                <Grid item xs={8}>
                    {props.viewMode &&
                        <>{props.input.collectCommFrom}</>
                    }
                    {!props.viewMode &&
                        <Autocomplete
                            disableClearable={true}
                            options={["Owners", "Chtrs"]}
                            renderInput={(params) => <TextField {...params} label="" error={
                                hasError(supportSheetData.enableValidation, props.input.collectCommFrom)
                            } />}
                            className={'support-sheet-send-draft-dropdown' + getErrorClass(supportSheetData.enableValidation, props.input.collectCommFrom)}
                            value={props.input.collectCommFrom}
                            onChange={(event: React.SyntheticEvent, value: string, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                props.input.collectCommFrom = value;
                                if (props.onInputChange) {
                                    props.onInputChange(props.input);
                                }
                            }}
                        />
                    }
                </Grid>
            </Grid>
            {
                !props.viewMode &&
                <Grid container>
                    <Grid item xs={4}>
                        <TextField
                            label="Total"
                            fullWidth
                            value={props.input.total}
                            onChange={(event) => {
                                props.input.total = event.target.value;
                                if (props.onInputChange) {
                                    props.onInputChange(props.input);
                                }
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, props.input.total)
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, props.input.total)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            label="Ours"
                            fullWidth
                            value={props.input.ours}
                            onChange={(event) => {
                                props.input.ours = event.target.value;
                                if (props.onInputChange) {
                                    props.onInputChange(props.input);
                                }
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, props.input.ours)
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, props.input.ours)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            label="Co-Bkrs"
                            fullWidth
                            value={props.input.coBrk}
                            onChange={(event) => {
                                props.input.coBrk = event.target.value;
                                if (props.onInputChange) {
                                    props.onInputChange(props.input);
                                }
                            }}
                            error={
                                hasError(supportSheetData.enableValidation, props.input.coBrk)
                            }
                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, props.input.coBrk)}
                        />
                    </Grid>
                </Grid>
            }
            <Table className="datatable">
                <TableHead>
                    <TableRow className="datatable-head">
                        <TableCell className='support-sheet-invoice-cell'>Invoice no</TableCell>
                        <TableCell className='support-sheet-invoice-cell'>Iss. Date</TableCell>
                        <TableCell className='support-sheet-invoice-cell'>Amount</TableCell>
                        <TableCell className='support-sheet-invoice-cell'>Rcv. Date</TableCell>
                        {
                            !props.viewMode && (props.type == MarketInfoType.TCT || props.type == MarketInfoType.TC) &&
                            <>
                                <TableCell className='support-sheet-invoice-cell' colSpan={2}>For period</TableCell>
                            </>
                        }
                        <TableCell className='support-sheet-invoice-cell'>Done</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.selectedItems.map((item: SupportSheetInvoiceModel, index: number) => (
                            <TableRow className='support-sheet-invoice-table-row'>
                                <TableCell className='support-sheet-invoice-cell'>
                                    <>{item.invoiceNo}</>
                                </TableCell>
                                <TableCell className='support-sheet-invoice-cell'>
                                    <>{Utility.DateFormat.formatDateString(item.issDate)}</>
                                </TableCell>
                                <TableCell className='support-sheet-invoice-cell'>
                                    <>{item.amount}</>
                                </TableCell>
                                <TableCell className='support-sheet-invoice-cell'>
                                    <>{Utility.DateFormat.formatDateString(item.rcvDate)}</>
                                </TableCell>
                                {
                                    !props.viewMode && (props.type == MarketInfoType.TCT || props.type == MarketInfoType.TC) &&
                                    <>
                                        <TableCell className='support-sheet-invoice-cell'>
                                            <Grid container>
                                                <Grid item xs={9}>
                                                    {Utility.DateFormat.formatDateString(item.forPeriodFrom)}
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <SupportSheetPeriod
                                                        title='Period From'
                                                        selectedDate={Utility.DateFormat.formatDateString(item.forPeriodFrom)}
                                                        onChange={(date) => {
                                                            item.forPeriodFrom = date;
                                                            if (props.onSelectedItemChange) {
                                                                props.onSelectedItemChange(props.selectedItems);
                                                            }
                                                        }}
                                                    >
                                                    </SupportSheetPeriod>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                        <TableCell className='support-sheet-invoice-cell'>
                                            <Grid container>
                                                <Grid item xs={9}>
                                                    {Utility.DateFormat.formatDateString(item.forPeriodTo)}
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <SupportSheetPeriod
                                                        title='Period From'
                                                        selectedDate={Utility.DateFormat.formatDateString(item.forPeriodTo)}
                                                        onChange={(date) => {
                                                            item.forPeriodTo = date;
                                                            if (props.onSelectedItemChange) {
                                                                props.onSelectedItemChange(props.selectedItems);
                                                            }
                                                        }}
                                                    >
                                                    </SupportSheetPeriod>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </>
                                }
                                <TableCell className='support-sheet-invoice-cell'>
                                    <Checkbox
                                        checked={item.isDone}
                                        onChange={(event) => {
                                            let doneState = event.target.checked;

                                            FixtureApi.SetFixtureDone({
                                                fixtureId: item.fixtureId,
                                                isDone: event.target.checked
                                            } as SetFixtureDoneParam)
                                                .then((response: BaseResponse<string>) => {
                                                    if (response.success) {
                                                        if (doneState) {
                                                            Utility.Alert.Success("Fixture is done");
                                                        } else {
                                                            Utility.Alert.Success("Fixture is undone");
                                                        }

                                                        item.isDone = doneState;
                                                        if (props.onSelectedItemChange) {
                                                            props.onSelectedItemChange(props.selectedItems);
                                                        }

                                                        dispatch(showLoading(false));
                                                    }
                                                    else {
                                                        dispatch(showLoading(false));
                                                        Utility.Alert.Error(response.message);
                                                    }
                                                })
                                                .catch((error) => {
                                                    dispatch(showLoading(false));
                                                    Utility.Alert.Error(error);
                                                });
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
            {!props.viewMode &&
                <Button
                    variant='outlined'
                    onClick={() => {
                        if (props.onInvoiceClick) {
                            props.onInvoiceClick();
                        }
                    }}
                >Add More Invoice</Button>
            }

        </>
    )
};

export default SupportSheetInvoice;